export default "__VITE_PUBLIC_ASSET__5fd24d76__"